import styled, { css } from 'styled-components'
// eslint-disable-next-line no-unused-vars
import { IButton } from '../../interfaces/IButton'

const getBackground = (background?: string) => {
  return background || 'var(--button-background)'
}

const getColor = (color?: string) => {
  return color || 'var(--button-color)'
}

const focus = css<IButton>`
  box-shadow: var(--button-shadow);
`

const hover = css<IButton>`
  &:before {
    background: linear-gradient(
      180deg,
      rgba(242, 242, 242, 0.2) 12.5%,
      transparent 43.23%
    );
  }
`

const active = css<IButton>`
  &::before {
    background: linear-gradient(
      180deg,
      transparent 20%,
      rgba(242, 242, 242, 0.3) 60%
    );
  }
`

const disabled = css<IButton>`
  filter: brightness(80%);
  pointer-events: none;
`

const loading = css<IButton>`
  ${(props) =>
    props.loading &&
    css`
      ${disabled}
    `}
`

const styleDefault = css<IButton>`
  background: ${(props) => getBackground(props.background)};

  color: ${(props) => getColor(props.color)};

  &:hover {
    ${hover}
  }

  &:focus {
    ${focus}
  }

  &:active {
    ${active}
  }
`

const outline = css<IButton>`
  background: transparent;

  color: ${(props) => getBackground(props.background)};

  &:hover {
    background: ${(props) => getBackground(props.background)};
    color: ${(props) => getColor(props.color)};

    ${hover}
  }

  &:focus {
    ${focus}
  }

  &:active {
    ${active}
  }
`

const link = css<IButton>`
  min-height: fit-content;

  border-color: transparent;
  background: transparent;

  padding: 0;
  border: 0;

  color: ${(props) => getColor(props.color || '#121212')};

  border-radius: 0;

  border-bottom: 1px solid transparent;

  &:hover {
    border-color: ${(props) => getColor(props.color || '#121212')};
  }
`

export const Container = styled.button.attrs({
  className: 'ui-intuix-button'
})<IButton>`
  border: 2px solid ${(props) => getBackground(props.background)};
  border-radius: 0.25rem;

  font-size: 1rem;

  min-height: 2.9rem;
  padding: 0.75rem 1.5rem;

  position: relative;

  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: 0.2s;

  &::before {
    content: '';

    transition: 0.2s;

    position: absolute;
    inset: 0;
  }

  i {
    display: flex;
    justify-content: center;
    align-items: center;

    margin-right: 0.5rem;
  }

  &:disabled {
    ${disabled}
  }

  ${loading}

  ${(props) => (!props.variant || props.variant === 'default') && styleDefault};

  ${(props) => props.variant && props.variant === 'outline' && outline};

  ${(props) => props.variant && props.variant === 'link' && link};
`
